import React from "react";
import { SOCIAL_MEDIA_ICONS } from "../../constants/constants";

const SocialMediaHandles = ({ handles }) => {
  const mapPlatformKey = (key) => {
    // Remove "business" prefix and normalize platform names
    const platformMap = {
      businessFacebookAccount: "facebook",
      businessInstagramAccount: "instagram",
      businessTikTokAccount: "tiktok",
      businessTwitterAccount: "twitter",
    };
    return platformMap[key] || key;
  };

  const formatUrl = (platform, url) => {
    if (url.startsWith("http") || url.startsWith("www")) {
      return url;
    }

    switch (platform) {
      case "facebook":
        return `https://facebook.com/${url}`;
      case "instagram":
        return `https://instagram.com/${url}`;
      case "tiktok":
        return `https://www.tiktok.com/@${url}`;
      case "twitter":
        return `https://twitter.com/${url}`;
      default:
        return url;
    }
  };

  return (
    <p className="text-sm font-normal text-grey-700">
      {Object.entries(handles).map(([key, url]) => {
        if (!url) return null; // Skip if the URL is empty
        const platform = mapPlatformKey(key); // Map the key to a platform name
        return (
          <a
            key={platform}
            href={formatUrl(platform, url)}
            className="mr-2 text-4xl text-grey-900"
            target="_blank"
            rel="noopener noreferrer"
          >
            <ion-icon
              name={SOCIAL_MEDIA_ICONS[platform] || SOCIAL_MEDIA_ICONS.globe}
            ></ion-icon>
          </a>
        );
      })}
    </p>
  );
};

export default SocialMediaHandles;
